import $ from 'jquery';

class TeamMemberDropdown {

  /*
   * @param $dropdown - jquery object
   * @param type - team member type, team_lead, adjuster or examiner
   */
  constructor($dropdown, type) {
    this.$dropdown = $dropdown;
    this.type = type;
  }

  val(value) {
    if (value === undefined) {
      return parseInt(this.$dropdown.val());
    } else {
      this.$dropdown.val(value);
      return this;
    }
  }

  deselect() {
    return this.val('');
  }

  onChange(f) {
    this.$dropdown.on('change', f);
    return this;
  }

  chosen() {
    this.$dropdown.chosen({
      // allow_single_deselect: true
    });
    return this;
  }

  updateChosen() {
    this.$dropdown.trigger('chosen:updated');

    let has_data = !isNaN(this.val());

    return this;
  }

  addOption(text, value, selected) {
    let $option = $('<option/>');
    $option.text(text).val(value);
    if (selected) {
      $option.attr('selected', 'selected');
    }

    this.$dropdown.append($option);

    return this;
  }

  clear() {
    this.$dropdown.empty();
    return this;
  }

  enable() {
    this.$dropdown.prop('disabled', false);
    return this;
  }

  disable() {
    this.$dropdown.prop('disabled', true);
    return this;
  }

  loading() {
    return this.clear()
      .addOption('Loading...', '', true)
      .disable()
      .updateChosen();
  }

  loadData(data) {

    this.clear()
      .addOption('Do not assign', '', false)
      .enable();

    for (let item of data) {
      this.addOption(item.name, item.id, false);
    }

    return this.updateChosen();
  }

  update(team_id) {

    let _this = this;

    let promise = new Promise(function(resolve, reject) {

      if (isNaN(team_id)) { // nothing is selected

        _this.clear()
          .addOption('Do not assign', '', true)
          .enable()
          .updateChosen();

        resolve();
      } else if (team_id) { // a team is selected
        _this.loading();

        axios.get('/webapi/team/' + team_id + '/' + _this.type + 's')
          .then(function(response) {
            _this.loadData(response.data);
            resolve();
          })
          .catch(function(error) {
            this.clear()
              .addOption('Loading failed', '', true)
              .disable()
              .updateChosen();

            resolve();
          });
      } else { // unassign is selected
        _this.clear()
          .addOption('Do not assign', '', true)
          .enable()
          .updateChosen();

        resolve();
      }
    });

    return promise;
  }
}

class Client {

  constructor() {}

  init() {
    this.$form = $('#client-form');
    this.$root = $('#client-contacts');

    if(!this.$form || !this.$root) return;

    this.$table = this.$root.find('table').first();
    this.$tbody = this.$table.find('tbody').first();
    this.$teams = this.$form.find('#default_team_id');
    this.team_leads = new TeamMemberDropdown(this.$form.find('#default_team_lead'), 'teamlead');
    this.examiners = new TeamMemberDropdown(this.$form.find('#default_examiner'), 'examiner');

    this.team_id = parseInt(this.$teams.data('default-team-id')) || '';
    this.team_lead_id = parseInt(this.$form.find('#default_team_lead_id').val()) || '';
    this.examiner_id = parseInt(this.$form.find('#default_examiner_id').val()) || '';

    this.$teams.chosen({
      // allow_single_deselect: true
    });
    this.team_leads.chosen();
    this.examiners.chosen();

    this.tpaEnabledChanged(this.$form.find('input[name=tpa_enabled]'));
  }

  deleteContact($tr) {
    let _this = this;
    let contactId = $tr.data('id');

    let $hidden = null;

    if (typeof contactId !== 'undefined') {
      $hidden = $('<input type="hidden" name="contacts_delete[]" />');
      $hidden.attr('value', contactId);
    }

    $tr.fadeOut(200, function() {
      _this.showEmptyRow();
      $tr.remove();
      if (typeof $hidden !== 'undefined' && $hidden) {
        _this.$root.append($hidden);
      }
    });
  }

  reset() {
    let $tr = this.$table.find('tr[data-row-type=new-contact]');

    $tr.find('input[data-field]').each(function(ix, el) {
      $(el).val(null);
    });

    $tr.find('[data-action]').prop('disabled', true);
  }

  copyDataRow($tr) {

    let _this = this;

    let $row = $tr.clone(false, false);
    $row.attr('data-row-type', 'contact');

    let $action = $row.find('button[data-action]');
    $action.removeClass('btn-primary')
      .addClass('btn-danger')
      .attr('data-action', 'delete-contact')
      .find('i').attr('class', 'fa fa-trash');

    $action.click(function() {
      let $tr = $(this).closest('tr[data-row-type=contact]');
      _this.deleteContact($tr);
    });

    let newId = uuid.v4();

    $row.find('[data-field]').each(function(ix, el) {
      let field = $(el).data('field');
      $(el).attr('name', 'contacts_new[' + newId + '][' + field + ']');
    });

    let phoneSelector = $row.find('[data-field="phone"]');
    let mask = new Inputmask("(9{3}) 9{3}-9{4}[ ext. 9{1,10}]");
    mask.mask(phoneSelector);

    return $row;
  }

  showEmptyRow() {
    if (this.$tbody.find('tr[data-row-type=contact]').length <= 1) {
      let $tr = $('<tr/>');
      $tr.attr('data-row-type', 'no-contacts')
        .appendTo(this.$tbody);

      let $td = $('<td/>');
      $td.attr('colspan', '5')
        .appendTo($tr);

      let $p = $('<p/>');
      $p.addClass('form-control-static')
        .text('No contacts')
        .appendTo($td);
    }
  }

  hideEmptyRow() {
    let $tr = this.$tbody.find('tr[data-row-type=no-contacts]');
    if ($tr.length) {
      $tr.remove();
    }
  }

  addContact($tr) {

    let $newTr = this.copyDataRow($tr);
    $newTr.hide();

    this.$tbody.append($newTr);

    this.hideEmptyRow();

    $newTr.fadeIn(200);

    this.reset();
  }

  setupEvents() {

    if(!this.$form || !this.$root) return;

    let _this = this;

    $('button[data-action=delete-contact]').click(function() {
      let $tr = $(this).closest('tr[data-row-type=contact]');
      _this.deleteContact($tr);
    });

    $('button[data-action=add-contact]').click(function() {
      let $tr = $(this).closest('tr');
      _this.addContact($tr);
    });

    $('tr[data-row-type=new-contact] input[data-field]').on('input', function() {
      let $tr = $(this).closest('tr');
      let $action = $tr.find('button[data-action=add-contact]');

      let fname = $tr.find('input[data-field=first_name]').val();
      let lname = $tr.find('input[data-field=last_name]').val();
      let email = $tr.find('input[data-field=email]').val();

      let has_data = !!(fname && fname.trim().length);
      has_data &= !!(lname && lname.trim().length);
      has_data &= !!(email && email.trim().length);

      if (has_data) {
        $action.removeClass('disabled')
        $action.prop('disabled', false);
      } else {
        $action.addClass('disabled')
        $action.prop('disabled', true);
      }
    });

    this.$teams.on('change', function(e) {
      _this.teamChanged();
    });

    this.$form.on('change', 'input[name=tpa_enabled]', function(e) {
      _this.tpaEnabledChanged($(this));
    });

    $('select#xa_claim_category_model').change(function(e) {
      _this.setXaClaimCategoryModel();
    });
    _this.setXaClaimCategoryModel();
  }

  isTeamChanged() {
    let team_id = parseInt(this.$teams.val());
    return team_id !== this.team_id;
  }

  teamChanged() {
    let team_id = parseInt(this.$teams.val());
    let has_data = !isNaN(team_id);
    let _this = this;

    Promise.all([this.team_leads.update(team_id), this.examiners.update(team_id)]).then(values => {
      _this.setExistingTeamLeadExaminer();
    });
  }

  tpaEnabledChanged(tpaInput) {
    this.$form.find('div#default_reserves').toggleClass('hidden');

    if (tpaInput.is(':checked')) {
      this.$form.find('input[name=financials_qb_enabled]').closest('.form-group').removeClass('d-none');
      this.$form.find('input[name=financials_approval_enabled]').closest('.form-group').removeClass('d-none');
    } else {
      this.$form.find('input[name=financials_qb_enabled]').closest('.form-group').addClass('d-none');
      this.$form.find('input[name=financials_approval_enabled]').closest('.form-group').addClass('d-none');
    }
  }

  setExistingTeamLeadExaminer() {
    let default_team_lead_id = parseInt(this.$teams.find('option:selected').data('team-lead-id') || 0);

    let new_team_lead_id = this.team_leads.val(this.isTeamChanged() ? default_team_lead_id : this.team_lead_id).val();
    if (isNaN(new_team_lead_id)) {
      this.team_leads.val('');
    }

    this.examiners.val(this.isTeamChanged() ? '' : this.examiner_id);

    this.team_leads.updateChosen();
    this.examiners.updateChosen();
  }

  setExistingValues() {

    if(!this.$form || !this.$root) return;

    this.$teams.trigger('change').trigger('chosen:updated');
  }

  setXaClaimCategoryModel() {

    let xccModelElement = $('select#xa_claim_category_model');
    let xccModelDescriptionElement = xccModelElement.next();
    let xaCatStormsElement = $('select#xa_cat_storms');
    let xaCatStormsBlock = xaCatStormsElement.parent().parent();
    let xccModel = xccModelElement.val();

    // Show appropriate description for selected model.
    let modelDescriptions = xccModelElement.data('descriptions');

    if (typeof xccModel !== 'undefined' && typeof modelDescriptions !== 'undefined') {
      xccModelDescriptionElement.html(modelDescriptions[parseInt(xccModel)]);

      // Show storms only for daily model.
      let dailyModel = xccModelElement.data('daily-model').toString();
      if (xccModel === dailyModel) {
        xaCatStormsBlock.removeClass('d-none');
      } else {
        xaCatStormsBlock.addClass('d-none');
      }

    }
  }

  load() {
    this.init();
    this.setupEvents();
    this.setExistingValues();
  }
}

export default new Client();
